import DefaultLayout from "../layouts/DefaultLayout";
import CustomText from "../components/common/general/CustomText/CustomText.js";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../components/common/general/CustomButton/CustomButton.js";
import List from "../components/admin/List/List.tsx";
import { EditTask } from "../components/svgs/common";
import { useGetAllTenantsQuery } from "../graphql/generated/graphql";
import { useNavigation } from "@react-navigation/native";

function TenantDashboardView() {
  const navigation = useNavigation();

  const { data, loading, error } = useGetAllTenantsQuery();

  const tenants = data?.getAllTenants.data.map((tenant) => {
    return {
      title: tenant.tenantDomain,
      rowItems: [{ text: `isLTI: ${tenant.isLTI}` }, { text: `Name: ${tenant.companionName}` }],
      icon: null,
      buttons: [{ icon: <EditTask />, onPress: () => handleEditTenant(tenant.id) }],
    };
  });

  const handleEditTenant = (id) => {
    navigation.navigate("Tenant Settings", { id });
  };

  const handleGoBack = () => {
    navigation.navigate("Admin");
  };

  return (
    <DefaultLayout pageHasChat={false}>
      <CustomButton
        text="← Back to Dashboard"
        onPress={handleGoBack}
        useTranslationText={false}
        styleType="transparent"
        size="s"
        style={styles.backButton}
      />
      <CustomSpacing size="m" />
      <CustomText
        role="header"
        text="Tenant Dashboard"
        size="l"
        textType="display"
        weight="ultraBold"
        useTranslationText={false}
      />
      <CustomSpacing size="large" />
      {!loading && !error && <List items={tenants} />}
    </DefaultLayout>
  );
}

const styles = {
  backButton: {
    alignSelf: "flex-start",
  },
};

export default TenantDashboardView;
